import { render } from "./DiscardButton.vue?vue&type=template&id=750c95f0&ts=true"
import script from "./DiscardButton.vue?vue&type=script&lang=ts"
export * from "./DiscardButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Widgets/DiscardButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "750c95f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('750c95f0', __exports__)) {
    api.reload('750c95f0', __exports__)
  }
  
  module.hot.accept("./DiscardButton.vue?vue&type=template&id=750c95f0&ts=true", () => {
    api.rerender('750c95f0', render)
  })

}


export default __exports__